import PropTypes from 'prop-types';

import {
  BaseDefaultProps,
  BasePropTypes,
} from '@/common/proptypes/Base/Base.proptypes';

export const StocksDefaultProps = {
  ...BaseDefaultProps,
  categories: [],
  companyAvailability: false,
  delayQuantity: 0,
  noDesktopLabel: false,
  origin: null,
  status: null,
  stock: null,
  stocks: [],
  unit: null,
};

export const StocksPropTypes = {
  ...BasePropTypes,
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      depth: PropTypes.number,
      id: PropTypes.number,
      label: PropTypes.string,
    }),
  ),
  companyAvailability: PropTypes.bool,
  delayQuantity: PropTypes.number,
  noDesktopLabel: PropTypes.bool,
  origin: PropTypes.string,
  status: PropTypes.string,
  stock: PropTypes.shape({}),
  stocks: PropTypes.arrayOf(PropTypes.shape({ delay: PropTypes.number })),
  unit: PropTypes.string,
};
